export default __webpack_public_path__ + "static/media/a3.80949585.svg";